import { Dispatch, AnyAction } from 'redux';
import { AppState } from '../redux';
import axios, { AxiosResponse, AxiosError } from 'axios';
import { 
    STORE_SUPPORT_REQUEST_DATA, 
    STORE_SUPPORT_TICKETNO, 
    STORE_SUPPORT_DATE, 
    STORE_SUPPORT_SUPPORTTYPE, 
    STORE_SUPPORT_STATUS, 
    SupportRequest, 
    SupportRequestTypes, 
    STORE_SUPPORT_REQUEST_TYPES, 
    STORE_SUPPORT_MTYPE,
    STORE_SUPPORT_CASENO
} from 'src/reducers/supportRequest';
import { push } from 'react-router-redux';
import { STORE_LOADER } from 'src/reducers/landingPage';

// export const saveQueryType = (querytype: string) => {
//     return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

//     };
// };

export const getSupportTypes = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    dispatch({ type: STORE_LOADER, loader: true } as AnyAction);
  
    await axios({
      method: 'post',
      url: `${getState().environment.API_URL
        }loadOrderData?listType=vwsptys`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        sessionid: getState().user.userDetails.s || ''
      }
    }).then(function (response: AxiosResponse) {

        dispatch({ type: STORE_LOADER, loader: false } as AnyAction);
    
        if (response.data.length === 1) {
          if (response.data[0].orderno !== '') {
            const supportRequestTypes: SupportRequestTypes[] = response.data;
            dispatch({ type: STORE_SUPPORT_REQUEST_TYPES, supportRequestTypes: supportRequestTypes } as AnyAction);
          } else {
            const supportRequestTypes: SupportRequestTypes[] = [];
            dispatch({ type: STORE_SUPPORT_REQUEST_TYPES, supportRequestTypes } as AnyAction);
          }
        } else {
          const supportRequestTypes: SupportRequestTypes[] = response.data;
          dispatch({ type: STORE_SUPPORT_REQUEST_TYPES, supportRequestTypes } as AnyAction);
        }
    
      }).catch(function (error: AxiosError) {
    
        dispatch({ type: STORE_LOADER, loader: false } as AnyAction);
    
        const supportRequestTypes: SupportRequestTypes[] = [];
        dispatch({ type: STORE_SUPPORT_REQUEST_TYPES, supportRequestTypes } as AnyAction);
      });
    
    };

export const getUserRequestData = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    const sessionid = getState().user.userDetails.s || '';

    await axios({
        method: 'post',
        url: `${getState().environment.API_URL}getTicketList?userCode=${encodeURIComponent(getState().user.userDetails.userName)}`,
        headers: {
            sessionid: sessionid || ''
        },
    }).then(async function (response: AxiosResponse) {
        if (response.data.length === 1) {
            if (response.data[0].ticketno !== '') {

                const supportRequestData: SupportRequest[] = response.data;
                dispatch({ type: STORE_SUPPORT_REQUEST_DATA, supportRequestData } as AnyAction);
            } else {

                const supportRequestData: SupportRequest[] = [];
                dispatch({ type: STORE_SUPPORT_REQUEST_DATA, supportRequestData } as AnyAction);
            }

        } else {

            const supportRequestData: SupportRequest[] = response.data;
            dispatch({ type: STORE_SUPPORT_REQUEST_DATA, supportRequestData } as AnyAction);
        }

    }).catch(function (error: AxiosError) {
        // ==> console.error(error);
        const supportRequestData: SupportRequest[] = [];
        dispatch({ type: STORE_SUPPORT_REQUEST_DATA, supportRequestData } as AnyAction);
    });
};

export const supportChatUser = (ticketno: string, date: string, supporttype: string, status: string, mtype: string, caseno: string) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        dispatch({ type: STORE_SUPPORT_TICKETNO, ticketno } as AnyAction);
        dispatch({ type: STORE_SUPPORT_DATE, date } as AnyAction);
        dispatch({ type: STORE_SUPPORT_SUPPORTTYPE, supporttype } as AnyAction);
        dispatch({ type: STORE_SUPPORT_STATUS, status } as AnyAction);
        dispatch({ type: STORE_SUPPORT_MTYPE, mtype } as AnyAction);
        dispatch({ type: STORE_SUPPORT_CASENO, caseno } as AnyAction);
        dispatch(push('/app/supportchat'));

        return true;
    };
};

export const goFeedBackPage = (ticketno: string, date: string, supporttype: string, status: string, mtype: string, caseno: string) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        dispatch({ type: STORE_SUPPORT_TICKETNO, ticketno } as AnyAction);
        dispatch({ type: STORE_SUPPORT_DATE, date } as AnyAction);
        dispatch({ type: STORE_SUPPORT_SUPPORTTYPE, supporttype } as AnyAction);
        dispatch({ type: STORE_SUPPORT_STATUS, status } as AnyAction);
        dispatch({ type: STORE_SUPPORT_MTYPE, mtype } as AnyAction);
        dispatch({ type: STORE_SUPPORT_CASENO, caseno } as AnyAction);
        dispatch(push('/app/support-feedback'));

        return true;
    };
};



// WEBPACK FOOTER //
// ./src/actions/supportRequestAction.ts